import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const businessCapacityEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-business-capacity" */ './src/BusinessCapacityEntryPoint.tsx'
			),
	),
	getPreloadProps: (entryPointRouteParams: EntryPointRouteParams) => {
		const { tenantContext } = entryPointRouteParams;

		return {
			queries: {},
			entryPoints: {},
			extraProps: {
				tenantContext,
			},
		};
	},
});
